import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import React from "react";
export default class ResourceDetails extends React.Component<any, any> {
    private renderTeams = (email: string) => {
        if (!Helper.hasValue(email)) {
            return null;
        }
        else {
            return (<>
                <tr>
                    <td>
                        <a className="contact-link" style={{ display: "flex", height: "25px", color: "black" }} href={`https://teams.microsoft.com/l/chat/0/0?users=${email}`} target="_blank" >
                            <span style={{ marginRight: "10px" }} >
                                <i className="fal fa-comments" aria-hidden="true"></i>
                                <div style={{ backgroundColor: "#464eb8", color: "white", borderRadius: "25%", height: "10px", width: "10px", position: "relative", top: "-10px", left: "12.5px" }}>
                                    <i className="fa-regular fa-t" aria-hidden="true" style={{ fontSize: "7px", position: "relative", top: "-11px", left: "2.5px" }}></i>
                                </div>
                            </span>
                            {email}
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <a className="contact-link" style={{ display: "flex", height: "25px", color: "black" }} href={`https://teams.microsoft.com/l/call/0/0?users=${email}`} target="_blank" >
                            <span style={{ marginRight: "10px" }} >
                                <i className="fal fa-headset" aria-hidden="true"></i>
                                <div style={{ backgroundColor: "#464eb8", color: "white", borderRadius: "25%", height: "10px", width: "10px", position: "relative", top: "-10px", left: "12.5px" }}>
                                    <i className="fa-regular fa-t" aria-hidden="true" style={{ fontSize: "7px", position: "relative", top: "-11px", left: "2.5px" }}></i>
                                </div>
                            </span>
                            {email}
                        </a>
                    </td>
                </tr>
            </>
            );
        }
    }


    private renderTeamsButton = (icon: string, link: string) => {
        return (
            <span onClick={this.createOnClickEvent(link)} >
                <i className={"fa-solid fa-" + icon} data-style="solid"></i>
                <i className={"fa-regular fa-" + icon} data-style="regular"></i>
                <div style={{ backgroundColor: "#464eb8", color: "white", borderRadius: "25%", height: "15px", width: "15px", position: "relative", top: "-12px", left: "17px" }}>
                    <i className="fa-regular fa-t" aria-hidden="true" style={{ fontSize: "10px", position: "relative", top: "-8px", left: "3.5px" }}></i>
                </div>
            </span>);
    }

    private createOnClickEvent = (link: string) => {
        return (event) => {
            window.open(link)
        };
    }


    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={data.Name + ", " + (data.Vorname ? data.Vorname : "") + ` (${data.Ressnr})`} keyPropValue={data.Ressnr} iconName={"person"} url={"Resource/Edit?id=" + encodeURIComponent(data.Ressnr)}>
                <table className="templateHoverTable">
                    <style>
                        {`.external__button {width: min-content;margin-right: 15px;}`}
                        {`.external__button i{font-size: x-large;}`}
                        {`.external__button i[data-style="solid"]{display: none}`}
                        {`.external__button i[data-style="regular"]{display: inline}`}
                        {`.external__button:hover i[data-style="solid"]{display: inline}`}
                        {`.external__button:hover i[data-style="regular"]{display: none}`}
                    </style>
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.Obergruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Gruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div style={{ display: "flex", marginTop: "5px", cursor: "pointer" }} >
                                    {
                                        Helper.isNullOrEmpty(data.Email) ? null : (
                                            <div className="external__button" onClick={this.createOnClickEvent(`mailto:${data.Email}`)} >
                                                <i className="fa-solid fa-envelope" data-style="solid"></i>
                                                <i className="fa-regular fa-envelope" data-style="regular"></i>
                                            </div>
                                        )
                                    }
                                    {
                                        Helper.isNullOrEmpty(data.Telefon) ? null : (
                                            <div className="external__button" onClick={this.createOnClickEvent(`tel:${data.Telefon}`)}>
                                                <i className="fa-solid fa-phone" data-style="solid"></i>
                                                <i className="fa-regular fa-phone" data-style="regular"></i>
                                            </div>
                                        )
                                    }
                                    {
                                        Helper.isNullOrEmpty(data.TeamsMail) ? null : (
                                            <>

                                                <div className="external__button">
                                                    {this.renderTeamsButton("comments", `https://teams.microsoft.com/l/chat/0/0?users=${data.TeamsMail}`)}
                                                </div>
                                                <div className="external__button">
                                                    {this.renderTeamsButton("headset", `https://teams.microsoft.com/l/call/0/0?users=${data.TeamsMail}`)}
                                                </div>
                                            </>
                                        )
                                    }


                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}